export const headers = {
  initialHeaders: [
    {
      title: "Fecha de creación",
      field: "workStartDate",
      child: "workStartDate",
    },
    {
      title: "Nombre del empleado",
      field: "employee",
      child: "fullName",
    },
    {
      title: "Regional",
      field: "regional",
      child: "name",
    },
    {
      title: "Cargo",
      field: "cargo",
      child: null,
    },
    {
      title: "Tiempo de gestación",
      field: "contractTypeFormat",
      child: "contractType",
    },
  ],
  otherHeaders: [
    {
      title: "Tipo de identificación",
      field: "employee",
      child: "documentType",
    },
    {
      title: "Regional",
      field: "regional",
      child: null,
    },
    {
      title: "Cargo",
      field: "cargo",
      child: null,
    },

    {
      title: "Estado",
      field: "status",
      child: null,
    },
  ],
  additionalInfo: [
    {
      title: "Observaciones",
      field: "lactationObservation",
      child: "null",
    },
    {
      title: "Fecha inicio",
      field: "lactationStartDate",
      child: null,
    },
    {
      title: "Fecha fin",
      field: "lactationEndDate",
      child: null,
    }
  ],
};

export const defaultSearchValues = {
  employeeSurname: null,
  licenseStartDate: null,
  regional: null,
  employeeName: null,
  licenseEndDate: null,
};

export const fakeData = {
  "maternityLicencePage": {
    "content": [
      {
        "id": "cba08f45-8fe7-4357-a55c-f14456027f24",
        "pregnancyStartDate": "2022-10-16 05:01:59",
        "estimatedDueDate": "2023-07-16 05:01:59",
        "licenseStartDate": "2023-06-16 05:01:59",
        "licenseEndDate": "2022-12-25 05:01:59",
        "requestDate": "2022-11-17 19:13:22",
        "employeeRequesting": {
          "id": "9d0c6c65-0230-49ec-aff7-17ba7c481479",
          "firstName": "Juancho",
          "secondName": "Aaaa",
          "surname": "Uribe",
          "secondSurname": "Lopez",
          "documentType": "CC",
          "document": "12121223",
          "charge": "Cargo 1.1",
          "chargeId": "4d4d955a-592f-40a5-9a88-6b2e122293ff",
          "regional": "Regional Santa Marta",
          "regionalId": "07d5b898-0560-4e2e-9fa3-75fc14553781",
          "username": "jangulorama2@gmail.com",
          "internalEmail": "jangulorama1@gmail.com",
          "gender": "MASCULINO",
          "fullName": "Juancho Aaaa Uribe Lopez"
        },
        "status": "ACTIVA",
        "cancelDate": null,
        "observation": null,
        "approvalDate": null,
        "rejectDate": null,
        "usernameReject": null,
        "usernameApprover": null,
        "gestationTime": 24,
        "contractType": "708ad680-150d-4699-8b64-c7cae20511f3",
        "contractTypeDescription": "Contrato Término Indefinido"
      }
    ],
    "pageable": {
      "sort": {
        "sorted": true,
        "unsorted": false,
        "empty": false
      },
      "offset": 0,
      "pageSize": 10,
      "pageNumber": 0,
      "paged": true,
      "unpaged": false
    },
    "totalPages": 1,
    "last": true,
    "totalElements": 1,
    "size": 10,
    "number": 0,
    "sort": {
      "sorted": true,
      "unsorted": false,
      "empty": false
    },
    "numberOfElements": 1,
    "first": true,
    "empty": false
  }
};

export const defaultValues = {
  firstName: null,
  secondName: null,
  surname: null,
  secondSurname: null,
  documentType: null,
  documentNumber: null,
  charge: null,
  duration: null,
  contractType: null,
  initDate: null,
  endDate: null,
  remuner: null,
  regional: null,
  licenseInitDate: null,
  licenseFinishDate: null,
  possibleDueDate: null,
  startDatePregnancy: null
};